import type { UseDatePartsState, DatePart } from './interfaces';

export const createInitialDatePartsState = (
  dateParts: readonly DatePart[]
): UseDatePartsState =>
  dateParts.reduce<UseDatePartsState>((state, part) => {
    state[part] = null;
    return state;
  }, {});
